
export default {
  middleware: 'gate',
}
